import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
// Rxjs dependencies.
import { BehaviorSubject, EMPTY } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
// SCW dependencies.
// Relative dependencies.
import { AuthService, ApiService } from '../../core/upgraded-providers';
import { ShowDlgGetAccessService } from '../../shared-dialogs.module/show-dlg-get-access.service';
// Relative dependencies.
import { ACCESS_HINT } from './constants';

const transformToBoolean = (value: boolean | string) :boolean => typeof value === 'string' ? value === '' : value;

@Component({
  selector: 'scw-shards-item-x',
  templateUrl: './item-x.component.pug',
  styleUrls: ['./item-x.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SCWShardsItemXComponent,
    },
  ],
})
export class SCWShardsItemXComponent implements ControlValueAccessor {
  protected readonly ACCESS_HINT = ACCESS_HINT;

  @Input() shard;

  private _disabled: boolean = null;
  @Input() set disabled(value: boolean | string) {
    this._disabled = transformToBoolean(value);
  }
  get disabled(): boolean | string {
    return this._disabled;
  }

  @Input() max = 0;

  private _value: number;
  @Input() set value(value: number) {
    this.writeValue(value);
  }
  get value(): number {
    return this._value;
  }

  get user() {
    return this._authService.Me;
  }

  @Output() valueChange = new EventEmitter<number>();

  constructor(
    private _route: ActivatedRoute,
    private _apiService: ApiService,
    private _authService: AuthService,
    private _showDlgGetAccess: ShowDlgGetAccessService,
  ) {
    // Noop.
  }

  protected onChangeCpu(value: number | string): void {
    if (typeof value === 'string') {
      value = parseInt(value, 10);
    }

    this._value  = value;
    this._emitChange(value);
  }

  protected onShowDlgGetAccess(): void {
    const amount = this._authService.Me.resources && this._authService.Me.resources.accessKey || 0

    this._showDlgGetAccess.show({
      amount,
    })
    .then((value) => {
      console.log('Access key received:', value);

      this._activateShardAccess(value);
    })
    .catch((error) => {
      console.error(error);
    });
  }

  private async _activateShardAccess(count: number): Promise<void> {
    try {
      await this._apiService.post('user/activate-shard-access', {
        shard: this.shard.name,
        count,
      });

      this._authService.check();
    } catch (err) {
      console.error('Failed to activate shard access:', err);
    }
  }

  private _onChange: any;
  private _onTouched: any;
  // START: ControlValueAccessor Interface
  public writeValue(value: any) {
    this._value = value;
  }

  public registerOnChange(fn: any) {
    this._onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this._onTouched = fn;
  }

  public setDisabledState?(disabled: boolean): void {
    this._disabled = transformToBoolean(disabled);
  }
  // END: ControlValueAccessor Interface

  private _emitChange(value: number): void {
    this.valueChange.emit(value);
    this._onChange && this._onChange(value);
  }
}
